import React from 'react';
import './App.css';
import Sidebar from './Sidebar';
import CourseArea from './CourseArea';
import Cart from './Cart'
import SearchAndFilter from './SearchAndFilter';
import data from './course_data.json'
import completed from './completed.json'
import {Row, Col} from 'antd'
import { Navbar} from 'react-bootstrap';
import 'antd/dist/antd.css';
import {notification} from 'antd'

const openNotificationWithIcon = (course, type, placement="bottomRight") => {
  notification[type]({
    message: 'Added to cart',
    description:
      course + ' has been successfully added to cart.',
    placement, 
  });
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allCourses: [],
      filteredCourses: [],
      subjects: [],
      cartCourses: {},
      completedCourses: [],
      ratedCourses: [],
      recommendedList: []
    };
  }

  componentDidMount() {
   this.loadInitialState()
  }

  async loadInitialState(){
    // let courseURL = "http://mysqlcs639.cs.wisc.edu:53706/api/react/classes";
    // let courseData = await (await fetch(courseURL)).json()
    let courseData = data;

    // let completedCoursesURL = "http://mysqlcs639.cs.wisc.edu:53706/api/react/students/5022025924/classes/completed";
    // let completedCoursesData = await(await fetch(completedCoursesURL)).json();
    let completedCoursesData = completed;

    this.ratedCourses = [];
    for(var i = 0; i < completedCoursesData.data.length; i++) {
      this.ratedCourses.push({course: completedCoursesData.data[i], rating: 0});
    }

    this.recommendedList = [];

    this.setState({allCourses: courseData, filteredCourses: courseData, subjects: this.getSubjects(courseData), completedCourses: completedCoursesData});
  }


  getSubjects(data) {
    let subjects = [];
    subjects.push("All");

    for(let i = 0; i < data.length; i++) {
      if(subjects.indexOf(data[i].subject) === -1)
        subjects.push(data[i].subject);
    }

    return subjects;
  }

  setCourses(courses) {
    this.setState({filteredCourses: courses})
  }

  addCartCourse(data) {
    let newCartCourses = JSON.parse(JSON.stringify(this.state.cartCourses))
    let courseIndex = this.state.allCourses.findIndex((x) => {return x.number===data.course})
    if (courseIndex === -1){
      return 
    }

    if('subsection' in data) {
      if(data.course in this.state.cartCourses) {
        if(data.section in this.state.cartCourses[data.course]) {
          let idx = this.findSubsectionIndex(data);
          if(idx !== -1) return;
          newCartCourses[data.course][data.section].push(data.subsection);
        }
        else {
          newCartCourses[data.course][data.section] = [];
          newCartCourses[data.course][data.section].push(data.subsection);
        }
      }
      else {
        newCartCourses[data.course] = {};
        newCartCourses[data.course][data.section] = [];
        newCartCourses[data.course][data.section].push(data.subsection);
      }
    }
    else if('section' in data) {
      if(data.course in this.state.cartCourses) {
        newCartCourses[data.course][data.section] = [];

        for(let i = 0; i < this.state.allCourses[courseIndex].sections[data.section].subsections.length; i++) {
          newCartCourses[data.course][data.section].push(this.state.allCourses[courseIndex].sections[data.section].subsections[i]);
        }
      
      
      }
      else {
        newCartCourses[data.course] = {};
        newCartCourses[data.course][data.section] = [];
        for(let i = 0; i < this.state.allCourses[courseIndex].sections[data.section].subsections.length; i++) { 
          newCartCourses[data.course][data.section].push(this.state.allCourses[courseIndex].sections[data.section].subsections[i]);
        }
      }
    }
    else {
      newCartCourses[data.course] = {};


      for (let i = 0; i < this.state.allCourses[courseIndex].sections.length; i++){
        newCartCourses[data.course][i] = [];

         for(let c= 0; c < this.state.allCourses[courseIndex].sections[i].subsections.length; c ++){
          newCartCourses[data.course][i].push(this.state.allCourses[courseIndex].sections[i].subsections[c]);
        }

      }


    }
    this.setState({cartCourses: newCartCourses});
    openNotificationWithIcon(data.course,'success');
  }

  findSubsectionIndex(data) {
    let newCartCourses = JSON.parse(JSON.stringify(this.state.cartCourses));

    for(var i = 0; i < newCartCourses[data.course][data.section].length; i++) {
      if(newCartCourses[data.course][data.section][i].number === data.subsection.number) {
        return i;
      }
    }
    return -1;
  }

  clearCart() {
    this.setState({cartCourses:{}});
  }

  removeCartCourse(data) {
    let newCartCourses = JSON.parse(JSON.stringify(this.state.cartCourses))
    console.log(newCartCourses);
    console.log(data.subsection);

    if('subsection' in data) {
      let idx = this.findSubsectionIndex(data);
      newCartCourses[data.course][data.section].splice(idx, 1);
      //newCartCourses[data.course][data.section].indexOf(data.subsection)
      // newCartCourses[data.course][data.section].splice(newCartCourses[data.course][data.section][data.subsection], 1);
      // delete newCartCourses[data.course][data.section][data.subsection]
      if(newCartCourses[data.course][data.section].length === 0) {
        delete newCartCourses[data.course][data.section];
      }
      if(Object.keys(newCartCourses[data.course]).length === 0) {
        delete newCartCourses[data.course];
      }
    }
    else if('section' in data) {
      delete newCartCourses[data.course][data.section];
      if(Object.keys(newCartCourses[data.course]).length === 0) {
        delete newCartCourses[data.course];
      }
    }
    else {
      delete newCartCourses[data.course];
    }
    this.setState({cartCourses: newCartCourses});
  }

  getCartData() {
    let cartData = [];

    for(const courseKey of Object.keys(this.state.cartCourses)) {
      let course = this.state.allCourses.find((x) => {return x.number === courseKey})

      cartData.push(course);
    }
    return cartData;
  }

  updateRatingList(course, rating) {
    // update Rating
    for(var i = 0; i < this.ratedCourses.length; i++) {
      if(this.ratedCourses[i].course === course) {
        this.ratedCourses[i].rating = parseInt(rating);
      }
    }
    
    // sort the list
    this.ratedCourses.sort((a,b) => b.rating - a.rating);

    // generate the recommendation
    this.genrateRecommendedKeywords();
  }  

  genrateRecommendedKeywords() {
    // first look at the first few top rated courses
    var keywordsOfTopRated = [];
    var subjectsOfTopRated = [];
    
    // look at the top 3 rated course with ratings >= 3
    for(var i = 0; i < 3; i++) {
      if(this.ratedCourses[i].rating >= 3) {
        var currCourseNum = this.ratedCourses[i].course;

        // look for the course object
        let currCourse = this.state.allCourses.find((course) => {return currCourseNum===course.number});
        keywordsOfTopRated = keywordsOfTopRated.concat(currCourse.keywords);
        subjectsOfTopRated = subjectsOfTopRated.concat(currCourse.subject);
      }
    }

    this.generateRecommendations(keywordsOfTopRated, subjectsOfTopRated);
  }

  generateRecommendations(keywordsOfTopRated, subjectsOfTopRated) {
    // call search and filter with each keywords
    var recommendations = [];
    // search for all keywords
    for(var i = 0; i < keywordsOfTopRated.length; i++){
      var searchForRecommendations = new SearchAndFilter();
      var resultsFromSearch = searchForRecommendations.searchAndFilter(this.state.allCourses, null, 'All', keywordsOfTopRated[i], 0, 10);
      
      // add each results to recommendations
      for(var j = 0; j < resultsFromSearch.length; j++) {
        if(!recommendations.includes(resultsFromSearch[j])) {
          recommendations.push(resultsFromSearch[j]);
        }
      }
    }

    //remove courses that are completed
    var completed = this.state.completedCourses.data;
    for(var i = 0; i < recommendations.length; i++) {
      if(completed.includes(recommendations[i].number)) {
        recommendations.splice(i, 1);
        i--;
      }
    }

    var recommendationsAfterSubjects = [];

    // search for all subjects using out given recommendations 
    for(var i = 0; i < subjectsOfTopRated.length; i++) {

      var searchForRecommendations = new SearchAndFilter();
      var resultsFromSearch = searchForRecommendations.searchAndFilter(recommendations, null, subjectsOfTopRated[i], 'All', 0, 10);
      
      for(var j = 0; j < resultsFromSearch.length; j++) {
        if(!recommendationsAfterSubjects.includes(resultsFromSearch[j])) {
          recommendationsAfterSubjects.push(resultsFromSearch[j]);
        }
      }
    }

    // if recommendationsAfterSubjects is empty, use recommendations
    if(recommendationsAfterSubjects.length === 0) {
      this.setState({recommendedList: recommendations});
    } else {
      this.setState({recommendedList: recommendationsAfterSubjects});
    }
  }

  getRecommendationsData() {
    var tempArray = [];

    if(typeof this.recommendedList === "undefined") {
      return tempArray;
    } else {
      return this.state.recommendedList;
    }
  }

  render() {
    return (
      <>
        <link
          rel="stylesheet"
          href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
          integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
          crossOrigin="anonymous"
        />

          <Navbar sticky="top" style={{backgroundColor: 'white', marginBottom: '40px'}}>
                <Col span={3}></Col>
                <div>
                <h1 style={{fontSize: "30px", fontWeight: "bolder", whiteSpace:'nowrap'}}>Search & Enroll</h1>
                </div>
                <Sidebar setCourses={(courses) => this.setCourses(courses)} courses={this.state.allCourses} subjects={this.state.subjects}/>
                <Col span={3}></Col> 
          </Navbar>

          <Row>
            <Col span={3}></Col>
            <Col span={13}>
                <CourseArea 
                  data={this.state.filteredCourses} 
                  addCartCourse={(data) => this.addCartCourse(data)} 
                  removeCartCourse={(data) => this.removeCartCourse(data)} 
                  cartCourses={this.state.cartCourses} 
                  completedCourses={this.state.completedCourses} 
                />
            </Col>
            <Col span={1}></Col>
            <Col span={4}>
              <Cart 
                data={this.getCartData()} 
                addCartCourse={(data) => this.addCartCourse(data)} 
                removeCartCourse={(data) => this.removeCartCourse(data)} 
                cartCourses={this.state.cartCourses} 
                clearCart={()=> this.clearCart()}
              >
              </Cart>
            </Col>
            <Col span={3}></Col>
          </Row>
      </>
    )
  }
}

export default App;
